<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { format } from 'svelte-i18n';
	import { postReq } from 'src/services/http';
	//Stores
		//Helpers
	import { real_id, real_id_z } from 'src/helpers/interface_helpers';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	//Types
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	//Design system components
	import { Toggle } from '@Shelly/shelly-design-system';
	import { capFirstChar } from 'src/helpers/utilities';

	$: settingsStore = getDeviceSettings(id);
	export let device;

	const id = real_id(device.id);

	let settings = $settingsStore,
		setting = 6,
		inverted = settings['Configuration:0'][setting] === 1,
		loading = false,
		cache = inverted;

	const sentRequest = async () => {
		inverted = !inverted;
		loading = true;

		const params = {
			id: real_id_z(device.id), //gateway's id
			a: 'call', //inclusion command
			cc: 'Configuration', //command class
			m: 'set', //method
			ep: 0, //endpoint
			params: JSON.stringify([{ parameter: setting, value: inverted ? 1 : 0 }]), //parameters parameter - setting index, value - setting value
		};
		const res: SettingRequest = await postReq(`/fast/device/zw`, {
			...params,
		});

		if (res.isok) {
			params.m = 'get'; //override method
			params.params = JSON.stringify([+setting]); //override params
			const res_get: SettingRequest = await postReq(`/fast/device/zw`, {
				...params,
			});
		}
		await onSettingsResponse(res, device);
		cache = inverted;
		loading = false;
	};
</script>

<Toggle checked={inverted} size="m" on:click={sentRequest} id="toggle-u7e8sah">
	{capFirstChar(
		$format('option_reverse_buttons', {
			default: 'If you enable this option, button 1 and 2 will be swapped.',
		}),
	)}
</Toggle>
